import { useState } from "react";
import "./alerts.scss";
import {
  useGetAdminAlertsQuery,
  useToggleAlertReadMutation,
} from "../../../features/api/adminApiSlice";
import LoadingSpinner from "../../loader/Loader";
import Select from "react-select";
import { customSelectStyles } from "../customStyles";

// Comments at the bottom
const AdminAlerts = () => {
  const { data: alerts, isLoading, isError } = useGetAdminAlertsQuery();
  const [toggleRead] = useToggleAlertReadMutation();
  const [filterType, setFilterType] = useState("all");

  if (isLoading) return <LoadingSpinner />;

  if (!alerts || alerts.length === 0) {
    return (
      <div className="no-content">
        <div>
          <p>No alerts yet</p>
        </div>
      </div>
    );
  } else if (isError)
    return (
      <div className="no-content">
        <div>
          <p>An Error occurred</p>
        </div>
      </div>
    );

  const handleToggleRead = async (id) => {
    try {
      await toggleRead(id).unwrap();
    } catch (err) {
      console.error("Failed to toggle read status", err);
    }
  };

  // Extract unique types for filter dropdown and create options array
  const types = Array.from(new Set(alerts.map((a) => a.type)));
  const typeOptions = [
    { value: "all", label: "All" },
    ...types.map((t) => ({
      value: t,
      label: t.replace("_", " "),
    })),
  ];

  // Filter alerts by type
  const filteredAlerts =
    filterType === "all" ? alerts : alerts.filter((a) => a.type === filterType);

  return (
    <div className="transactions-container">
      <div className="dashboard-top-section">
        <div className="dash-top-flex">
          <h1 className="dashboard-title">Alerts </h1>
        </div>
      </div>
      <div className="filters">
        <Select
          styles={customSelectStyles}
          value={typeOptions.find((option) => option.value === filterType)}
          onChange={(selectedOption) => setFilterType(selectedOption.value)}
          options={typeOptions}
          isSearchable={false}
          placeholder="Filter by type"
          // Optional: Add custom styles
          // styles={customSelectStyles}
        />
      </div>
      {/* Admin informational message */}
      <div className="admin-info-message">
        <p>
          Alerts are color-coded by type for quick scanning:
          <span className="legend subscription_cleanup">
            Subscription Cleanup
          </span>
          <span className="legend new_video"> New Video</span>
          <span className="legend new_product"> New Product</span>
          <span className="legend user_activity"> User Activity</span>
          <span className="legend critical_error"> Critical Errors</span>
          <span className="legend webhook_failure"> Webhook Failures</span>
        </p>
      </div>
      <table className="transactions-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Message</th>
            <th>Created</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {filteredAlerts.map((alert) => {
            const typeClass = `alert-type-${alert.type}`;
            return (
              <tr
                key={alert._id}
                className={`${alert.read ? "read" : "unread"} ${typeClass}`}
              >
                <td>{alert.type.replace("_", " ")}</td>
                <td>{alert.message}</td>
                <td>{new Date(alert.createdAt).toLocaleString()}</td>
                <td className="refund-actions">
                  <button
                    onClick={() => handleToggleRead(alert._id)}
                    className={alert.read ? "mark-unread" : "mark-read"}
                  >
                    {alert.read ? "Mark Unread" : "Mark Read"}
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AdminAlerts;
